import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Best Csf Rhinorrhoea repair Treatment & Surgery in Delhi India</title>
            <meta name="description" content="Get safe and effective CSF Rhinorrhoea Repair Surgery in Delhi, India. Learn about treatment, endoscopic procedure, recovery, and cost." />
            <meta name="keywords" content="CSF rhinorrhea treatment, rhinorrhoea surgery, CSF rhinorrhoea radiology,CSF rhinorrhea causes,CSF rhinorrhoea diagnosis" />
            <link rel="canonical" href="https://entdelhi.com/repair-of-csf-rhinorrhoea/" />
            <meta property="og:title" content="Best Csf Rhinorrhoea repair Treatment & Surgery in Delhi India" />
            <meta property="og:description" content="Get safe and effective CSF Rhinorrhoea Repair Surgery in Delhi, India. Learn about treatment, endoscopic procedure, recovery, and cost." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
